import { DefinitionTooltip } from '@carbon/react';
import { DragHorizontal } from '@carbon/react/icons';
import {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core';
import style from './draggable-header-icon.module.scss';

interface DraggableHeaderIconIconProps {
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
}

export const DraggableHeaderIcon = ({
  attributes,
  listeners,
}: DraggableHeaderIconIconProps) => {
  return (
    <div className={style.sortIcon}>
      <DefinitionTooltip
        className={style.toolTip}
        align="top"
        definition="Move"
        openOnHover
        {...attributes}
        {...listeners}
      >
        <DragHorizontal />
      </DefinitionTooltip>
    </div>
  );
};
